<template>
  <div class="home">
    <div class="swiper-container" style="height: 100%;">
      <div class="swiper-wrapper" style="height: 100%;">
        <div class="swiper-slide" style="height: 100%;" v-for="(item, index) in bannerList" :key="index"
          @click="handleC(item)">
          <img :src="`${$getFullPath(item.picture)}`" width="100%" height="100%" style="object-fit: cover;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper";
import Swiper from "swiper";

import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";

import { getHomeBanner } from "@/api/index";

export default {
  data() {
    return {
      bannerList: [],
      slides: [
        { image: "path/to/image1.jpg", altText: "Image 1" },
        { image: "path/to/image1.jpg", altText: "Image 12" },
        { image: "path/to/image1.jpg", altText: "Image 13" },
        { image: "path/to/image2.jpg", altText: "Image 2" },
        // ...
      ],
      swiper: null,
      advertisementImg: "",
    };
  },
  components: {
    // Swiper,
    // SwiperSlide
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
    this.getbanner();
  },
  methods: {
    handleC(item) {
      if (item.jumpLink) {
        window.location.href = item.jumpLink;
      }
    },
    getbanner() {
      getHomeBanner().then((res) => {
        console.log(res);
        this.bannerList = res.data.data;
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.update();
          } else {
            this.initSwiper();
          }
        });
      });
    },
    initSwiper() {
      var mySwiper = new Swiper(".swiper", {
        autoplay: true, //可选选项，自动滑动
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  // width: 95%;
  margin: 0 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 24vh;
  // height: 59.285*4.2px;
  padding: 0.5vh 2vh 2vh;
  background-size: 100% 100%;
  background-image: url('../assets/home/100.png');
  // background-size: cover !important;
  // height: 156px;
  // background-image: url("../assets/images/banner_bkg.png");
  position: relative;
    top: -12px;

}

.swiper-container {
  width: 100%;
  // height: 110px;
  // height: 33.2*7.5px;
  /* 或者其他你需要的高度 */
  padding: 7.1*4.2px 0px 4.76*4.2px;
  overflow: hidden;

  @media (max-width: 430px) {
    height: 110px;
  }
}

::v-deep .swiper-pagination-bullet {
  background: #323436;
}

::v-deep .swiper-pagination-bullet-active {
  background: #3fa2c7;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.el-carousel {
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  /deep/ .el-carousel__button {
    // 指示器按钮
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 50%;
    background-color: #323436;
  }

  /deep/ .is-active .el-carousel__button {
    // 指示器激活按钮
    background: #3fa2c7;
  }

  /deep/ .el-carousel__container {
    height: 100%;
  }
}
</style>
